import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TreeModule } from '@ali-hm/angular-tree-component';
import { UIRouterModule } from '@uirouter/angular';
import { CoreWidgetsModule } from '../../widgets/core.widgets.module';
import { CoreFiltersModule } from '../../core/core.filters.module';
import { DOCMAN_STATES } from './docman.routes.config';
import { DocmanPanelComponent } from './docmanPanel/docman.panel.controller';
import { FileContextMenuComponent } from './fileContextMenu/file.context.menu.controller';
import { FolderContextMenuComponent } from './folderContextMenu/folder.context.menu.controller';
import { FileDeleteModalComponent } from './fileDeleteModal/file.delete.modal.controller';
import { FileVersionDeleteModalComponent } from './fileVersionDeleteModal/file.version.delete.modal.controller';
import { FileSettingsEditModalComponent } from './fileSettingsEditModal/file.settings.edit.modal.controller';
import { FileOrganizerComponent } from './fileOrganizer/file.organizer.controller';
import { FileOrganizerModalComponent } from './fileOrganizerModal/file.organizer.modal.controller';
import { FileRenameModalComponent } from './fileRenameModal/file.rename.modal.controller';
import { FolderAddModalComponent} from './folderAddModal/folder.add.modal.controller';
import { FolderRenameModalComponent } from './folderRenameModal/folder.rename.modal.controller';
import { FolderEditModalComponent} from './folderEditModal/folder.edit.modal.controller';
import { FolderDeleteModalComponent} from './folderDeleteModal/folder.delete.modal.controller';
import { FileVersionEditModalComponent } from './fileVersionEditModal/file.version.edit.modal.controller';
import { FileVersionRestoreModalComponent } from './fileVersionRestoreModal/file.version.restore.modal.controller';

@NgModule({
    imports: [
      CommonModule,
      FormsModule,
      CoreFiltersModule,
      CoreWidgetsModule,
      TreeModule,
      UIRouterModule.forChild({ states: DOCMAN_STATES })
    ],
    providers:  [
    ],
    declarations: [
      DocmanPanelComponent,
      FileContextMenuComponent,
      FolderContextMenuComponent,
      FileDeleteModalComponent,
      FileVersionDeleteModalComponent,
      FileSettingsEditModalComponent,
      FileOrganizerComponent,
      FileOrganizerModalComponent,
      FileRenameModalComponent,
      FolderAddModalComponent,
      FolderRenameModalComponent,
      FolderEditModalComponent,
      FolderDeleteModalComponent,
      FileVersionEditModalComponent,
      FileVersionRestoreModalComponent
    ],
    exports: [
      DocmanPanelComponent,
      FileContextMenuComponent,
      FolderContextMenuComponent,
      FileDeleteModalComponent,
      FileVersionDeleteModalComponent,
      FileSettingsEditModalComponent,
      FileOrganizerComponent,
      FileOrganizerModalComponent,
      FileRenameModalComponent,
      FolderAddModalComponent,
      FolderRenameModalComponent,
      FolderEditModalComponent,
      FolderDeleteModalComponent,
      FileVersionEditModalComponent,
      FileVersionRestoreModalComponent
    ],
})
export class DocmanModule {
    constructor() { }
}
